import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./SendLostPassword.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import * as YStyled from "../../Styleds";
import { CSSTransition } from 'react-transition-group';
const SendLostPassword = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    useEffect(() => {
        setInProp(true);
        document.title = "重設密碼";
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "SendLostPassword"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            <YStyled.Span fontWeight={500} size={22} style={{alignSelf:"flex-start",margin:"1rem 0 1.5rem 0"}}>重設密碼</YStyled.Span>
                            <YStyled.Col>
                                <YStyled.Span fontWeight={400} size={17} >將重設密碼連結傳送至</YStyled.Span>
                                <YStyled.Span fontWeight={400} size={17} >abc123@gmail.com</YStyled.Span>
                            </YStyled.Col>
                            <YStyled.BTN3 normalBg="#000" normalColor="white" style={{ width: "100%", padding: ".8rem", borderRadius: "10px" ,marginTop:"1.5rem"}} onClick={e => {
                                addModalType({cls:"SetNewPassword"})
                            }}>
                                <YStyled.Span size={17} >傳送驗證信</YStyled.Span>
                            </YStyled.BTN3>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(SendLostPassword);